import { AxiosErrorHandler, Card, InfinityLoading, Loading, Text } from 'ui';
import { Notification } from '../notification';
import { useNotificationsInfiniteQuery } from '../queries';

const NotificationsList = () => {
  const { data, error, fetchNextPage, hasNextPage, isFetching, isLoading } = useNotificationsInfiniteQuery({
    pagination: { pageSize: 20 },
  });

  const notifications = data?.pages.flat() ?? [];

  return (
    <AxiosErrorHandler error={error}>
      {isLoading ? (
        <Loading />
      ) : (
        <Card shrinked>
          {notifications.length === 0 ? (
            <Text>You have no unread notifications.</Text>
          ) : (
            notifications.map((notification) => <Notification key={notification.id} notification={notification} />)
          )}
          <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
        </Card>
      )}
    </AxiosErrorHandler>
  );
};

export default NotificationsList;
